"use strict";

exports.__esModule = true;
exports.byTool = exports.byTime = exports.byState = exports.byShift = exports.byProcess = exports.byOperator = exports.byNativeCode = exports.byKind = exports.byInstance = exports.byDevice = exports.byConditionType = exports.byConditionText = exports.byConditionLevel = exports.byActivity = void 0;
var _timeAggregationBinMapping = require("../timeAggregationBinMapping");
var byTime = exports.byTime = {
  name: "workday",
  label: "Aggregate by",
  type: "workday",
  binName: "by_workday",
  fieldName: "dimensions.workday",
  aggType: "date_histogram",
  options: {
    calendar_interval: "",
    script: {
      scriptName: "exclude_days_of_week",
      ignoreScript: true
    }
  },
  props: {
    section: "aggregates",
    // Refers to the section name. Can be used to validate dependsOn
    valuePath: "options.calendar_interval",
    dependsOn: [{
      section: "filters",
      id: "options.scriptParams.daysToExclude",
      should: {
        strategy: "exists" // Similar to ES. Validate whether the value exists or not
      }
    }],
    values: {
      source: "input",
      data: _timeAggregationBinMapping.timeGrouping
    },
    mergeProps: {
      sortIndex: "workday"
    }
  }
};
var byConditionText = exports.byConditionText = {
  name: "condition_text",
  label: "Condition Text",
  type: "string",
  binName: "by_condition_text",
  fieldName: "dimensions.condition_text",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "condition_text"
    }
  }
};
var byConditionLevel = exports.byConditionLevel = {
  name: "condition_level",
  label: "Level",
  type: "string",
  binName: "by_condition_level",
  fieldName: "dimensions.condition_level",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "condition_level"
    }
  }
};

// Note: Name should match whatever comes after by_ in the binName. Hence giving it this way.!
var byConditionType = exports.byConditionType = {
  name: "data_item_type",
  label: "Type",
  type: "string",
  binName: "by_data_item_type",
  fieldName: "measures.data_item_type",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "data_item_type"
    }
  }
};
var byNativeCode = exports.byNativeCode = {
  name: "native_code",
  label: "Native Code",
  type: "string",
  binName: "by_native_code",
  fieldName: "entity.native_code",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "native_code"
    }
  }
};
var byDevice = exports.byDevice = {
  name: "device",
  label: "Device",
  type: "deviceName",
  binName: "by_device",
  fieldName: "entity.device",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "device"
    }
  }
};
var byShift = exports.byShift = {
  name: "shift",
  label: "Shift",
  type: "string",
  binName: "by_shift",
  fieldName: "dimensions.shift",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "shift"
    }
  }
};
var byKind = exports.byKind = {
  name: "kind",
  label: "Kind",
  type: "string",
  binName: "by_kind",
  fieldName: "dimensions.part_kind",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "kind"
    }
  }
};
var byState = exports.byState = {
  name: "state",
  label: "State",
  type: "state",
  binName: "by_state",
  fieldName: "dimensions.state",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "state"
    }
  }
};
var byActivity = exports.byActivity = {
  name: "activity",
  label: "Activity",
  type: "activity",
  binName: "by_activity",
  fieldName: "dimensions.activity",
  aggType: "terms",
  options: {
    missing: " "
  },
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "activity"
    }
  }
};
var byProcess = exports.byProcess = {
  name: "part_process",
  label: "Part Process",
  type: "string",
  binName: "by_part_process",
  fieldName: "dimensions.part_process",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "part_process"
    }
  }
};
var byInstance = exports.byInstance = {
  name: "part_instance",
  label: "Part Instance",
  type: "string",
  binName: "by_part_instance",
  fieldName: "dimensions.part_instance",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "part_instance"
    }
  }
};
var byOperator = exports.byOperator = {
  name: "operator",
  label: "Operator",
  type: "string",
  binName: "by_operator",
  fieldName: "dimensions.operator",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    // Refers to fieldName as it is not going to change,
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "operator"
    }
  }
};
var byTool = exports.byTool = {
  name: "tool_number",
  label: "Tool",
  type: "string",
  binName: "by_tool_number",
  fieldName: "dimensions.tool_number",
  aggType: "terms",
  options: {},
  props: {
    section: "aggregates",
    valuePath: "fieldName",
    dependsOn: [],
    values: {},
    mergeProps: {
      sortIndex: "tool_number"
    }
  }
};